module.exports = __webpack_public_path__ + "static/img/58.d00ca7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/58.png
// module id = evtj
// module chunks = 2